import { AppAccessDenied } from "components";
import useAppPermission from "hooks/useAppPermission";
import { FC, Fragment, ReactNode } from "react";
import { PermissionType } from "utils/constants/permissions";

interface WrapperProps {
    permissionCode: PermissionType;
    children: ReactNode;
}
const Wrapper: FC<WrapperProps> = ({ permissionCode, children }) => {
    const { allow } = useAppPermission();
    if (!allow(permissionCode)) {
        return <AppAccessDenied homeUrl="/administrator" />
    }
    return <Fragment>{children}</Fragment>
}
export default Wrapper;